import React, { useContext, useEffect } from 'react';

import { BoardsContext } from 'common/containers/BoardsContainer';

import type { InBoardFilter } from 'common/automations/constants';
import Input from 'common/uiV3/Input';
import { Select } from 'common/uiV3/Select';

interface Props {
  value: InBoardFilter['value'];
  onChange: (condition?: InBoardFilter['condition'], value?: InBoardFilter['value']) => void;
  required: boolean;
}

const BoardURLName = ({ required, ...props }: Props) => {
  const boards = useContext(BoardsContext);

  const { value, onChange } = props;
  const selectedBoard = Array.isArray(boards)
    ? boards.find((board) => board.urlName === value)
    : null;
  const boardsLoaded = Array.isArray(boards) && boards.length > 0;

  // On init, select the first board
  useEffect(() => {
    if (!selectedBoard && boardsLoaded) {
      onChange('equals', boards[0].urlName);
    }
  }, [boardsLoaded, selectedBoard, boards, onChange]);

  // Boards could potentially be loading. If so, just chill out for a bit
  if (!boardsLoaded) {
    return (
      <div className="filterField1of1">
        <Input readOnly value="No boards exist" />
      </div>
    );
  }

  return (
    <>
      <div className="filterField1of2">
        <Input readOnly value="is" />
      </div>
      <div className={required ? 'filterField2of2-required' : 'filterField2of2'}>
        <Select
          onValueChange={(option) => onChange('equals', option)}
          options={boards.map((board) => ({ label: board.name, value: board.urlName }))}
          placeholder=""
          value={selectedBoard ? selectedBoard.urlName : undefined}
          fullWidth
          isSearchable={boards.length > 5}
        />
      </div>
    </>
  );
};
export default BoardURLName;
